import { createI18n } from 'vue-i18n';

// 动态导入语言文件
const messages = {};
const locales = import.meta.glob('./locales/*.json', { eager: true });

for (const path in locales) {
    const lang = path.match(/\/([a-z]+)\.json$/)[1]; // 提取语言代码，例如 "en" 或 "zh"
    messages[lang] = locales[path].default;
}

/**
 * 检测默认语言
 * 优先使用url中的语言
 * 没有 lang 参数时，根据域名后缀判断
 * 其它情况，回退到浏览器语言
 */
const getDefaultLanguage = () => {
    // const urlParams = new URLSearchParams(window.location.search);
    // const langParam = urlParams.get("lang");
    // if (langParam && ["zh", "en"].includes(langParam)) {
    //     return langParam;
    // }

    // const hostname = window.location.hostname;
    // if (hostname.endsWith(".com.cn") || hostname == "cfw-test.youbanban.com") {
    //     return "zh";
    // } else if (hostname.endsWith(".com")) {
    //     return "en";
    // }

    const lang = navigator.language || navigator.userLanguage;
    return lang.includes('zh') ? 'zh' : 'en';
};

// 创建 i18n 实例
const i18n = createI18n({
    locale: getDefaultLanguage(), // 默认语言
    fallbackLocale: 'en', // 备用语言
    messages, // 动态加载的语言资源
});

export const switchLanguage = async (lang) => {
    if (!i18n.global.availableLocales.includes(lang)) {
        const langMessages = await import(`./locales/${lang}.json`);
        i18n.global.setLocaleMessage(lang, langMessages.default);
    }
    i18n.global.locale = lang; // 切换语言
};

export default i18n;
